import { render } from "./shopMenu.vue?vue&type=template&id=35563ab0&scoped=true&ts=true"
import script from "./shopMenu.vue?vue&type=script&lang=ts"
export * from "./shopMenu.vue?vue&type=script&lang=ts"

import "./shopMenu.vue?vue&type=style&index=0&id=35563ab0&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35563ab0"]])

export default __exports__